
(function(){
  "use strict";
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function hide(el){ if(!el) return; el.style.setProperty('display','none','important'); el.setAttribute('aria-hidden','true'); }
  function removeOverlayLike(el){
    if(!el) return;
    hide(el);
    if (el.parentElement && /overlay|modal|popup|newsletter|klaviyo|privy|mailchimp|signup/i.test((el.parentElement.className||'') + ' ' + (el.parentElement.id||''))) hide(el.parentElement);
    document.documentElement.classList.remove('modal-open','popup-open','newsletter-open');
    document.body && document.body.classList.remove('modal-open','popup-open','newsletter-open');
    document.body && (document.body.style.overflow='');
  }
  function initPopupRescue(){
    var closeSelectors = [
      '[aria-label="Close"]','[aria-label="Cerrar"]','[data-close]','[data-dismiss]','[data-popup-close]',
      '.klaviyo-close-form','.needsclick.kl-private-reset-css-Xuajs1','.mc-closeModal','.privy-dismiss','.fancybox-close-small',
      '.mfp-close','.modal__close','.popup-close','.newsletter__close','.close'
    ];
    function scan(){
      document.querySelectorAll(closeSelectors.join(',')).forEach(function(btn){
        if (btn.dataset.nmBoundClose) return;
        btn.dataset.nmBoundClose='1';
        btn.addEventListener('click', function(){ removeOverlayLike(btn.closest('[role="dialog"], .modal, .popup, .klaviyo-form, .newsletter-popup, .needsclick') || btn.parentElement); }, true);
      });
      document.querySelectorAll('.modal-backdrop,.klaviyo-form,.privy,.needsclick').forEach(function(el){
        var txt=(el.textContent||'').toLowerCase();
        if(/correo|newsletter|suscr|promoci|sign up|subscribe/.test(txt)){
          var rect=el.getBoundingClientRect();
          if(rect.width>220 && rect.height>120){
            var hasClose = el.querySelector(closeSelectors.join(','));
            if(!hasClose){
              var emergency = document.createElement('button');
              emergency.type='button';
              emergency.className='nm-emergency-close';
              emergency.textContent='×';
              emergency.setAttribute('aria-label','Cerrar');
              emergency.addEventListener('click', function(){ removeOverlayLike(el); }, true);
              el.appendChild(emergency);
            }
          }
        }
      });
    }
    scan();
    var mo=new MutationObserver(scan); mo.observe(document.documentElement,{childList:true,subtree:true});
    setTimeout(function(){
      document.querySelectorAll('.modal-backdrop,.klaviyo-form,.privy,.needsclick').forEach(function(el){
        var txt=(el.textContent||'').toLowerCase();
        if(/correo|newsletter|suscr|promoci|sign up|subscribe/.test(txt)) hide(el);
      });
    }, 12000);
  }
  function initSearchBoost(){
    var btns=document.querySelectorAll('.nm-search-toggle');
    btns.forEach(function(btn){ btn.classList.add('nm-search-toggle--boost'); btn.setAttribute('title','Buscar'); });
  }
  ready(function(){ initPopupRescue(); initSearchBoost(); });
})();
